import { createGrid, themeQuartz } from 'ag-grid-community'
import { showElement } from '@local_modules/generic/dom/show-element.js'
import { hideElement } from '@local_modules/generic/dom/hide-element.js'
import { showLoading } from '@local_modules/generic/dom/show-loading.js'

import { optionSelectorData } from '../../../../../modules/option-selector/data.js'
import { loadDataStatements } from './load/load-data.js'

import { makeGridData } from './make-grid-data.js'
import { makeRowPinnedTop } from './pinned-row-top.js'
import { context } from './context.js'
import { setNeededData } from './set-needed-data.js'

export let gridApi

const myTheme = themeQuartz.withParams({
  pinnedColumnBorder: 'none',
  rowBorder: 'none',
  wrapperBorder: 'none'
})

const containerId = 'grid'

/**
 *
 */
export async function updateView () {
  console.log(' ---- ')
  console.log(' ')
  console.log('updateView')
  console.log('optionSelectorData', optionSelectorData)
  console.log('context', context)
  showElement('statementLoadingMessage')
  hideElement('statementContainer')
  showLoading('statementLoadingMessage')

  // 1. Load data
  setNeededData(context, optionSelectorData)
  context.dates = optionSelectorData.dates

  await loadDataStatements(context)
  context.chartOfAccountsMap = context.chartOfAccounts.reduce((acc, account) => {
    acc[account.id] = account
    return acc
  }, {})

  // 2. Update view settings
  // context.gridMethod = 'byAllAccounts'
  context.gridMethod = 'byLayout'

  context.viewDecimals = optionSelectorData.decimals || 0
  context.timeDirection = optionSelectorData.timeDirection || 'ascending'

  context.grid = context.grid || {}
  context.grid.openedGroups = context.grid.openedGroups || new Set()

  const gridContainerElement = document.getElementById(containerId)
  const containerHasContent = gridContainerElement.querySelectorAll('div')?.length

  console.time('show the grid')
  const gridData = makeGridData(context)

  const gridRows = gridData.rows
  const gridColumns = gridData.columns
  // console.log('grid', gridRows, gridColumns)
  // console.log('gridApi', gridApi, containerHasContent, gridContainerElement)

  if (gridApi && containerHasContent) {
    // console.log('update the grid')
    gridApi.updateGridOptions({
      rowData: gridRows,
      columnDefs: gridColumns
    })
  } else {
    // console.log('CREATE the grid')
    const gridOptions = {
      rowData: gridRows,
      columnDefs: gridColumns,
      defaultColDef: {
        sortable: false
        // filter: true,
        // floatingFilter: true
      },
      autoSizeStrategy: {
        type: 'fitCellContents'
      },
      rowSelection: {
        mode: 'singleRow',
        checkboxes: false,
        enableClickSelection: true
      },
      getRowId: (cellParams) => cellParams.data.id,
      getRowHeight: function (params) {
        if (Number.isInteger(params.data.rowHeight)) {
          return params.data.rowHeight
        }
      },
      onFilterChanged: function () {
        console.log('gridApi.onFilterChanged')
        // gridApi.setGridOption('pinnedTopRowData', makeRowPinnedTop(gridApi))
      },
      onCellClicked: function (cellParams) {
        console.log('gridApi.onCellClicked', cellParams)
        // context.valueBalance = context.valueBalance === 'balance' ? 'period' : 'balance'
        // updateView()
      },
      context,
      theme: myTheme,
      loadThemeGoogleFonts: true
    }

    gridApi = createGrid(gridContainerElement, gridOptions)
    // console.log('grid created')
    gridApi.setGridOption('pinnedTopRowData', makeRowPinnedTop(context, gridApi))
  }

  enableValueColumnsResizing(gridApi)

  console.timeEnd('show the grid')

  hideElement('statementLoadingMessage')
  showElement('statementContainer')
}

function enableValueColumnsResizing (gridApi) {
  gridApi.getColumns().forEach(function (column) {
    column.addEventListener('widthChanged', function (eventParams) {
      if (!eventParams.column?.colDef?.context?.isValue) return
      const newWidth = eventParams.column.getActualWidth()

      gridApi.getColumns().forEach(function (column2) {
        if (!column2.colDef.context?.isValue) return
        if (!column2.colId === eventParams.column.colId) return

        gridApi.setColumnWidths([
          {
            key: column2,
            newWidth
          }
        ])
      })
    })
  })
}
